(ns frontend.actions.exit-opportunity
  (:require [frontend.conn :as conn]
            [promesa.core :as p]))

(defn *->disable [data on-success! on-error!]
  (-> (conn/sendp! :exit-opportunity/disable
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->put-on-hold [data on-success! on-error!]
  (-> (conn/sendp! :exit-opportunity/put-on-hold
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->lost! [data on-success! on-error!]
  (-> (conn/sendp! :exit-opportunity/lost
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->won! [data on-success! on-error!]
  (-> (conn/sendp! :exit-opportunity/won
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->resurrect! [data on-success! on-error!]
  (-> (conn/sendp! :exit-opportunity/resurrect
                   data)
      (p/then on-success!)
      (p/catch on-error!)))
